// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wh-8";
export var container = "_wh-0";
export var radioDot = "_wh-5";
export var radioDotSelected = "_wh-6";
export var row = "_wh-1";
export var rowFirst = "_wh-2";
export var rowLast = "_wh-3";
export var rowSelected = "_wh-4";
export var strikethrough = "_wh-7";